import { defineNuxtPlugin } from '#app';
import { getBasePath } from '~/utils/getBasePath';

export default defineNuxtPlugin(() => {
  const router = useRouter();

  let isPopState = false;
  window.addEventListener('popstate', () => { isPopState = true; });

  // Сброс скролла ДО отрисовки новой страницы: scrollBehavior применяется после
  // первого кадра, из-за чего на старой позиции мелькал футер.
  router.beforeEach((to, from) => {
    if (!from?.name) return;
    if (isPopState) {
      isPopState = false;
      return;
    }

    if (getBasePath(to.fullPath) !== getBasePath(from.fullPath)) {
      window.scrollTo(0, 0);
    }
  });
});
